// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"505":"page-404","937":"page-form"}[chunkId] || chunkId) + "." + {"453":"1e79c8df","505":"5f168bae","937":"fd5980f9"}[chunkId] + ".chunk.js";
};